import axios from 'axios';
import { TokenManager } from '@/utils/api-client-factory';

const API_BASE_URL =
  import.meta.env.VITE_API_URL ||
  'https://main-api-production-1bb6.up.railway.app/api';

export interface UserStatsV2Response {
  totalOpenedPositions: number;
  totalClosedPositions: number;
  totalUsdAmount: number;
  totalPnl: number;
  totalMoneyEarned: number;
  bestPosition?: {
    id: string;
    symbol: string;
    positionType: string;
    amount: number;
    leverage: number;
    realizedPnl: number;
    pnlPercentage: number;
    closedAt: string;
  };
  worstPosition?: {
    id: string;
    symbol: string;
    positionType: string;
    amount: number;
    leverage: number;
    realizedPnl: number;
    pnlPercentage: number;
    closedAt: string;
  };
  cumulativePnlData: Array<{
    date: string;
    cumulativePnl: number;
  }>;
  positionMarkers: Array<{
    date: string;
    symbol: string;
    exchangeName: string;
    exchangeCode: string;
    tradeOrigin: string;
    pnlPercentage: number | null;
    realizedPnl: number | null;
    alert: {
      exchange: string;
      exchangeType: string;
      tier: number;
      type: string;
    } | null;
  }>;
}

interface ApiResponse<T> {
  success: boolean;
  data: T;
  error?: string;
}

/**
 * Get user statistics v2 with cumulative PnL graph data
 */
export const getUserStatsV2 = async (userId: string): Promise<UserStatsV2Response> => {
  try {
    const token = TokenManager.getToken();
    const headers: Record<string, string> = {
      'Content-Type': 'application/json',
    };

    if (token) {
      headers['Authorization'] = `Bearer ${token}`;
    }

    const response = await axios.get<ApiResponse<UserStatsV2Response>>(
      `${API_BASE_URL}/trading/stats/v2/${userId}`,
      { headers }
    );

    if (!response.data.success) {
      throw new Error(response.data.error || 'Failed to get user statistics');
    }

    return response.data.data;
  } catch (error) {
    console.error('[StatsAPI] Error fetching user stats v2:', error);
    throw error;
  }
};

